import React from "react";

import { DataBlockRequestFormHookProps } from "@/domains/evidence-requests/types";
import { SimpleModalProps } from "@/components_v2/Modal/types";
import {
  AnswerResponse,
  BaseSurvey,
  OptionResponse,
  OptionTypeValue,
  SectionResponse,
  SectionStatisticsResponse,
  SuggestionStatusType,
} from "@/redux/survey/types";
import {
  DataBlockListResponse,
  DataBlockResponse,
} from "@/redux/datablocks/types";
import { DataBlocksFiltersState } from "@/domains/datablocks/types";
import { SuggestionType } from "@/shared/utils/constants";

export interface DataBlockRequestsTabProps {
  onCreateRequestsClick: () => void;
}

export interface DataBlockRequestsSurveyModalFooterProps {
  formHook: DataBlockRequestFormHookProps;
  onBackToTabs: () => void;
}

export interface SectionProgressCircleProps {
  requiredQuestionsCount: number;
  answeredRequiredQuestionsCount: number;
  color: string;
}

export interface SectionProgressBarProps {
  sections: SectionStatisticsResponse[];
}

export interface SurveyDataBlockModalProps extends SimpleModalProps {
  selectedBlocks: DataBlockResponse[];
  setSelectedBlocks: (value: DataBlockResponse[]) => void;
  filters: Partial<DataBlocksFiltersState>;
  initialData: Record<string, any>;
}

export enum activeTabs {
  dataBlocks = "dataBlocks",
  requests = "requests",
}

export enum ViewTypes {
  Tabs = "TABS",
  RequestsForm = "REQUESTS_FORM",
}

export interface DataBlocksTabProps {
  selectedBlocks: DataBlockResponse[];
  setSelectedBlocks: (value: DataBlockResponse[]) => void;
  currentQuestion?: number;
  filters: Partial<DataBlocksFiltersState>;
  onCreateDataBlockClick: () => void;
}

export interface SurveySectionFormProps {
  surveyId: number;
  sectionId: number;
}

export interface SectionContentProps {
  sectionId: number;
}

export interface SectionHeaderProps {
  section: SectionResponse;
}

export interface SectionFooterProps {
  section: SectionResponse;
}

export interface SectionNavigationButtonProps {
  section: SectionResponse;
  direction: "previous" | "next";
}

export interface OptionEntitiesProps {
  option: OptionResponse;
  answer: AnswerResponse;
  handleSubmit: (value: DataBlockListResponse[]) => Promise<any>;
  isLoading?: boolean;
}

export interface DisabledSuggestions {
  itemIds: number[];
  choiceTextValues: string[];
}

export type ApplySuggestionsValue =
  | { type: typeof SuggestionType.TEXT; value: string }
  | {
      type: typeof SuggestionType.CHOICE;
      optionIds: Set<number>;
      choiceTextValues: Set<string>;
    }
  | { type: typeof SuggestionType.PROMPT; blockIds: Set<number> };

export interface QuestionSuggestionsProps {
  questionId: number;
  questionType: OptionTypeValue;
  onDismiss: () => void;
  onApply: (value: ApplySuggestionsValue) => void;
  disabledSuggestions?: DisabledSuggestions;
}

export interface SuggestionStatusBadgeProps {
  suggestionStatus: SuggestionStatusType;
  sourceSurvey: BaseSurvey | null;
  isDisabled: boolean;
  onClick: (e: React.MouseEvent) => void;
}
